define("tmds/geometry/Point", [
	"jquery",
	"./Geometry",
	"../validator"
], function($, Geometry, validator) {
	"use strict";

	/**
	 * construct a new point
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			x: 200,
	 * 			y: 100
	 * 		}
	 * @note all option members are optional
	 */
	var Point = function(options) {
		
		this.x = 0;
		this.y = 0;
		
		if (options != undefined) {			
			if(validator.isDataObject(options)) {				
				['x', 'y'].forEach(function(prop) {					
					if(options[prop] != undefined) {				
						if(! validator.isNumber(options[prop]))
							throw new Error('Invalid ' + prop + ' value - ' + options[prop] + ' passed');
							
						this[prop] = options[prop];
					}
				}, this);
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
		}
	};
	
	/**
	 * get the extent that wraps the point geometry
	 * @return {Object} in JSON format of tmds.geometry.Extent
	 */
//	function toExtent() {
//		return {
//			xmin: this.x,
//			ymin: this.y,
//			xmax: this.x,
//			ymax: this.y
//		};
//	}
	
	function toJson() {
		return {
			x: this.x,
			y: this.y,
			type: this.type
		};
	}
	
	Point.prototype = $.extend(Object.create(Geometry.prototype), {		
		declaredClass: "tmds.geometry.Point",
		type: "Point",
//		'toExtent' : toExtent,
		'toJson' : toJson
	});
	
	return Point;
});